import { persistStateTypes } from 'a/reducers/persistStateReducer';
import {
  GAME_ID,
  IS_INTERMEDIATE_SAVING_DISABLED,
  REDUX_ACTIONS,
  CURRENT_SAVE_DATA_VERSION,
} from '../../data/constants';

const initialState = {
  isFetched: false,
  savedFiles: {},
};

const savedDataReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case persistStateTypes.REQUESTERROR_GAMESTATE:
      return {
        ...state,
        isFetched: true,
      };

    case persistStateTypes.REQUESTRESPONSE_GAMESTATE: {
      const { GameData } = action.stateData[GAME_ID];

      if (
        GameData === undefined ||
        IS_INTERMEDIATE_SAVING_DISABLED ||
        GameData.version === undefined ||
        GameData.version < CURRENT_SAVE_DATA_VERSION
      ) {
        return {
          ...state,
          isFetched: true,
        };
      }

      return {
        ...state,
        isFetched: true,
        savedFiles: { ...GameData },
      };
    }

    case REDUX_ACTIONS.SET_SAVED_GAME_STATE: {
      return {
        ...state,
        savedFiles: { ...action.payload },
      };
    }

    default:
      return state;
  }
};

export default savedDataReducer;
